export default __webpack_public_path__ + "static/media/Waspsting Bolts.abd7e8d8.jpg";